import React from "react";
import { Card, Dropdown, Button } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Link } from "react-router-dom";

export default function InvoicesCard() {

const invoices = [
{
id:"#INVO02",
title:"Redesign Website",
company:"Logistics",
amount:"$3560",
status:"Unpaid",
img:"https://randomuser.me/api/portraits/men/32.jpg"
},
{
id:"#INVO05",
title:"Module Completion",
company:"Yip Corp",
amount:"$4175",
status:"Unpaid",
img:"https://randomuser.me/api/portraits/women/44.jpg"
},
{
id:"#INVO03",
title:"Change on Emp Module",
company:"Ignis LLP",
amount:"$6985",
status:"Unpaid",
img:"https://randomuser.me/api/portraits/men/55.jpg"
},
{
id:"#INVO02",
title:"Changes on the Board",
company:"Ignis LLP",
amount:"$1457",
status:"Unpaid",
img:"https://randomuser.me/api/portraits/women/65.jpg"
},
{
id:"#INVO06",
title:"Hospital Management",
company:"HCL Corp",
amount:"$6458",
status:"Paid",
img:"https://randomuser.me/api/portraits/men/15.jpg"
}
];

return (

<Card className="invoice-card task-card h-100">

<div className="invoice-header">

<h6>Invoices</h6>

<div className="header-actions">

<Dropdown>
<Dropdown.Toggle className="dropdown-btn">
Invoices <KeyboardArrowDownIcon style={{fontSize:18}}/>
</Dropdown.Toggle>

<Dropdown.Menu>
<Dropdown.Item>Invoices</Dropdown.Item>
<Dropdown.Item>Receipts</Dropdown.Item>
</Dropdown.Menu>
</Dropdown>

<Button className="date-btn">
<FiCalendar className="me-1"/> This Week
</Button>

</div>

</div>

<div className="invoice-body">

{invoices.map((item,index)=>(
<div key={index} className="invoice-row">

<div className="invoice-left">

<img src={item.img} alt="" />

<div>
<h6>{item.title}</h6>
<p>{item.id} • {item.company}</p>
</div>

</div>

<div className="invoice-middle">
<p>Payment</p>
<h6>{item.amount}</h6>
</div>

<div className="invoice-right">

<span className={item.status==="Paid"?"status-paid":"status-unpaid"}>

<span className="dot"></span> {item.status}

</span>

</div>

</div>
))}

<Link  className="text-decoration-none"  to="/invoices-page" >
<Button className="view-btn">View All</Button>
</Link>


</div>

<style>{`

.invoice-card{
border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;

box-shadow:0 2px 5px rgba(0,0,0,0.05);
}

.invoice-header{
display:flex;
justify-content:space-between;
align-items:center;
padding:15px;
border-bottom:1px solid #eee;
}

.invoice-header h6{
margin:0;
font-weight:600;
font-size:16px;
}

.header-actions{
display:flex;
gap:10px;
}

.dropdown-btn{
background:#fff;
border:none;
font-size:13px;
}

.date-btn{
background:#fff;
border:1px solid #ddd;
font-size:13px;
}

.invoice-body{
padding:10px 15px 15px;
}

.invoice-row{
display:flex;
align-items:center;
justify-content:space-between;
padding:6px 0;
border-bottom:1px solid #f3f3f3;
}

.invoice-left{
display:flex;
align-items:center;
gap:10px;
}

.invoice-left img{
width:40px;
height:40px;
border-radius:50%;
}

.invoice-left h6{
margin:0;
font-size:14px;
font-weight:600;
}

.invoice-left p{
margin:0;
font-size:12px;
color:#777;
}

.invoice-middle p{
margin:0;
font-size:12px;
color:#777;
}

.invoice-middle h6{
margin:0;
font-size:14px;
font-weight:600;
}

.status-unpaid{
background:#ffe6e6;
color:#ff3b3b;
padding:4px 10px;
border-radius:6px;
font-size:12px;
display:flex;
align-items:center;
gap:5px;
}

.status-paid{
background:#e6f7ec;
color:#1bbf72;
padding:4px 10px;
border-radius:6px;
font-size:12px;
display:flex;
align-items:center;
gap:5px;
}

.dot{
width:6px;
height:6px;
border-radius:50%;
background:currentColor;
display:inline-block;
}

.view-btn{
width:100%;
margin-top:12px;
background:#f6f6f6;
border:1px solid #ddd;
color:#333;
font-size:13px;
}
@media (max-width:576px){
.task-card{
margin-top:15px;
}
}

@media (max-width:992px){
.task-card{
margin-top:15px;
}
}

@media (max-width:1024px){
.task-card{
margin-top:15px;
}
}

`}</style>

</Card>

);
}